export default "__VITE_ASSET__i8PgaGzX__"